import { render, staticRenderFns } from "./AdicionalesEtapas.vue?vue&type=template&id=45472833&"
import script from "./AdicionalesEtapas.vue?vue&type=script&lang=js&"
export * from "./AdicionalesEtapas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports